/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface ISendEmailActionBlockDocumentationScope extends ng.IScope {
        workflowBlock: models.SendEmailWorkflowBlock,
        workflowEmailConfigurations: Wars.Domain.Model.EmailConfiguration[]
        emailConfiguration: Wars.Domain.Model.EmailConfiguration
    }

    export class SendEmailActionBlockDocumentation implements IDirective {
        public controller = ['$scope', SendEmailActionBlockDocumentationController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/documentation/sendEmailActionBlock.html';
        public restrict: string = "E";

        public scope: any = {
            workflowBlock: '=',
            workflowEmailConfigurations: '=',
        };

        public link(scope: ISendEmailActionBlockDocumentationScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: SendEmailActionBlockDocumentationController): void {
        }
    }

    export class SendEmailActionBlockDocumentationController implements IController {
        private $scope: ISendEmailActionBlockDocumentationScope;

        constructor($scope: ISendEmailActionBlockDocumentationScope) {
            this.$scope = $scope;

            this.$scope.$watch("workflowBlock", () => {
                this.setEmailConfiguration();
            });

            this.$scope.$watch("workflowEmailConfigurations", () => {
                this.setEmailConfiguration();
            });
        }

        private setEmailConfiguration() : void {
            if (!this.$scope.workflowBlock ||
                this.$scope.workflowBlock.sendEmailDto === undefined ||
                this.$scope.workflowBlock.sendEmailDto.emailConfigurationId === undefined ||
                this.$scope.workflowEmailConfigurations === undefined)
            {
                this.$scope.emailConfiguration = undefined;
                return;
            }
            var emailConfigurationId = this.$scope.workflowBlock.sendEmailDto.emailConfigurationId;
            this.$scope.emailConfiguration = Enumerable.from(this.$scope.workflowEmailConfigurations).singleOrDefault(i => i.id == emailConfigurationId)
        }
    }
}

warsApp.registerDirective('SendEmailActionBlockDocumentation', []);